import {
  Shield, HeartPulse, Brain, Bone, Droplets, Wind, Flame, Eye,
  Scale, Sparkles, Zap, Baby, Sun, Leaf,
} from "lucide-react";

// Map a health-concern name to a fitting vector icon + accent colour.
const MAP = [
  { kw: ["immun", "cold", "cough", "flu", "fever", "infection"], Icon: Shield, color: "#3E8E4C" },
  { kw: ["heart", "cardio", "bp", "blood pressure", "cholesterol"], Icon: HeartPulse, color: "#C70017" },
  { kw: ["diabet", "sugar", "glucose"], Icon: Droplets, color: "#2563EB" },
  { kw: ["brain", "memory", "stress", "anxiety", "mental", "sleep", "insomnia", "mind"], Icon: Brain, color: "#7C3AED" },
  { kw: ["joint", "bone", "arthrit", "knee", "back pain", "muscle"], Icon: Bone, color: "#B45309" },
  { kw: ["digest", "stomach", "gut", "acid", "constipat", "liver", "gastr", "piles"], Icon: Flame, color: "#EA580C" },
  { kw: ["hair", "scalp", "dandruff"], Icon: Sparkles, color: "#0D9488" },
  { kw: ["skin", "acne", "glow", "pigment", "beauty"], Icon: Sun, color: "#DB2777" },
  { kw: ["respirat", "lung", "asthma", "breath"], Icon: Wind, color: "#0891B2" },
  { kw: ["weight", "obes", "fat", "slim"], Icon: Scale, color: "#65A30D" },
  { kw: ["eye", "vision", "sight"], Icon: Eye, color: "#4F46E5" },
  { kw: ["energy", "fatigue", "stamina", "vital", "strength"], Icon: Zap, color: "#D97706" },
  { kw: ["women", "pregnan", "fertil", "period", "menstru", "child", "kids"], Icon: Baby, color: "#DB2777" },
  { kw: ["kidney", "urine", "urinary"], Icon: Droplets, color: "#0EA5E9" },
];

export function concernVisual(name = "") {
  const n = String(name).toLowerCase();
  for (const m of MAP) if (m.kw.some((k) => n.includes(k))) return { Icon: m.Icon, color: m.color };
  return { Icon: Leaf, color: "#3E8E4C" };
}
